// Import Modules
import { RouteObject } from 'react-router-dom';

const PaidCallSupport: RouteObject = {
  path: 'paid-call-support/home',
  children: [
    {
      index: true,
      path: '',
      lazy: async () => {
        const Home = await import('./Home/Home');
        return { Component: Home.default };
      },
    },
  ],
};

export default PaidCallSupport;
